<template>
  <section class="landing-about">
    <div class="landing-container">
      <div class="landing-about-grid">
        <!-- Left Content -->
        <div class="landing-about-text">
          <div class="landing-tagline">About SARPA</div>
          <h2 class="landing-about-title">
            Working Together for<br />
            a <span>Safer Madhya Pradesh</span>
          </h2>
          <p class="landing-about-desc">
            SARPA is a citizen-focused initiative developed in collaboration with the Madhya Pradesh Forest Department to ensure safe and scientific handling of snake-related incidents across the state.
          </p>
          
          <ul class="landing-about-list">
            <li class="landing-about-item">
              <span class="landing-check-icon">
                <v-icon color="var(--landing)" size="14">mdi-check</v-icon>
              </span>
              24/7 Support for Snake Related Incidents
            </li>
          </ul>
        </div>

        <!-- Right Image -->
        <div class="landing-about-img-container">
          <img :src="require('@/assets/images/landing/new2.jpeg')" alt="About SARPA MP" class="landing-about-img" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeAbout'
};
</script>
